import axiosInstance from "./axiosInstance";

const AppVersionService = {
  getAllVersions: async () => {
    try {
      const response = await axiosInstance.get("/appVersion/");
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },
  createVersion: async (payload) => {
    try {
      const response = await axiosInstance.post("/appVersion/create", payload);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },
  updateVersion: async (id, payload) => {
    try {
      const response = await axiosInstance.put(`/appVersion/${id}`, payload);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },
  deleteVersion: async (id) => {
    try {
      const response = await axiosInstance.delete(`/appVersion/delete/${id}`);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },
};

export default AppVersionService;
